import { useController, useFormContext } from 'react-hook-form';
import React from 'react';
import {
    SwitchProps as MuiSwitchProps,
    FormControlLabelProps,
    Alert,
    Switch,
} from '@mui/material';
import WarningIcon from '@mui/icons-material/Warning';

export interface AlertSwitchProps
    extends Partial<Omit<MuiSwitchProps, 'defaultValue'>> {
    name: string;
    label: string;
    defaultValue?: boolean;
    LabelProps?: Partial<FormControlLabelProps>;
    severity?: 'error' | 'warning' | 'info' | 'success';
}

const AlertSwitch: React.FC<AlertSwitchProps> = ({
    defaultValue,
    name,
    label,
    LabelProps = {},
    disabled,
    severity = 'warning',
    ...rest
}) => {
    const { control } = useFormContext();
    const {
        field: { value, ...field },
    } = useController({
        name,
        control,
        defaultValue,
    });

    return (
        <Alert
            severity={severity}
            icon={
                <WarningIcon
                    sx={{
                        color: '#EC8031',
                        fontSize: '24px',
                    }}
                />
            }
            action={
                <Switch
                    {...field}
                    sx={{
                        mr: 1,
                    }}
                    disabled={disabled}
                    checked={value}
                    {...rest}
                />
            }
            sx={{
                alignItems: 'center',
                color: '#2B395B',
                my: 1,
                '.MuiAlert-action': { pt: 0 },
            }}
        >
            {label}
        </Alert>
    );
};

export default AlertSwitch;
